/* eslint-disable max-lines */
import { EMediaType } from '../types/gallery';

export enum EFeatureContainerSize {
  Xs = '548px',
  Xl = '1076px',
  Md = '824px',
}
export interface ISwiperOptions {
  spaceBetween: number;
  slidesPerView?: number | 'auto';
}
export const STANDARD_SWIPER_OPTIONS: ISwiperOptions = {
  spaceBetween: 10,
  slidesPerView: 'auto',
};

export interface IStandardImage {
  mediaType: EMediaType.Image;
  thumbnailUrl: string;
  fullUrl: string;
}

export interface IStandardVideo {
  mediaType: EMediaType.Video;
  thumbnailUrl: string;
  fullUrl: string;
}

export type TStandardMedia = IStandardImage | IStandardVideo;

export interface IStandardOffer {
  id: number;
  title: string;
  description: string;
  thumbnailUrl: string;
  media: IStandardImage[];
}

export interface IStandardFeature {
  id: number;
  title: string;
  offers: IStandardOffer[];
}

export interface IStandard {
  title: string;
  description: string;
  features: IStandardFeature[];
}

export const standard: IStandard = {
  title: 'ПИК-Стандарт',
  description:
    'Это правила, по которым мы строим наши проекты. Сегодня любой жилой квартал ПИК — это уютные дворы-парки, современные школы и детские сады, квартиры с готовой отделкой и большими окнами. Ведь самое важное — чтобы дома было хорошо',
  features: [
    {
      id: 1,
      title: 'Дома',
      offers: [
        {
          id: 2,
          title: 'Долговечные фасады',
          description:
            'Керамическая плитка или клинкерный кирпич — для любой технологии мы выбираем самые долговечные материалы.',
          thumbnailUrl: require('./assets/2/1068x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/2/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/2/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/2/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 3,
          title: 'Светлые первые этажи',
          description:
            'На первых этажах стеклянные двери и высокие потолки — от 3,6 до 4,2 метра. А ещё здесь два входа: с улицы и со двора.',
          thumbnailUrl: require('./assets/3/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/3/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/3/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/3/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 4,
          title: 'Вместительные лифты',
          description:
            'Мы устанавливаем надёжные, быстрые и вместительные лифты. Они бывают двух видов: для 8 и 13 человек. В таких лифтах не будет тесно ни с покупками, ни с коляской, ни с велосипедом. А ещё наши лифты тихие: уровень их шума чуть выше, чем у современного холодильника. Благодаря специальным покрытиям лифты надолго сохранят безупречный внешний вид.',
          thumbnailUrl: require('./assets/4/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/4/1024x800.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
      ],
    },
    {
      id: 5,
      title: 'Квартира',
      offers: [
        {
          id: 6,
          title: 'Кладовые',
          description:
            'Чтобы освободить место в квартирах, на -1 этажах наших домов есть кладовые — там можно хранить вещи, которые не нужны каждый день. Кладовые бывают разной площади, в среднем 4–7 м². Поместятся и велосипед, и лыжи, и покрышки.',
          thumbnailUrl: require('./assets/6/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/6/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/6/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 7,
          title: 'Большие окна',
          description:
            'В наших квартирах площадь остекления на 30% больше, чем в стандартных домах, а подоконники — ниже, на уровне 50–60 см от пола. Поэтому в квартирах много естественного света. Окна мы делаем на собственных заводах из качественного профиля с многокамерными стеклопакетами.',
          thumbnailUrl: require('./assets/7/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/7/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/7/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 8,
          title: 'Разнообразие планировок',
          description:
            'В наших домах десятки разных планировок: сможете выбрать квартиру и с идеальной детской, и с удобным рабочим кабинетом, и с большой кухней-гостиной для вечеринок.',
          thumbnailUrl: require('./assets/8/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/8/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/8/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/8/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 9,
          title: 'Отделка',
          description:
            'Готовая отделка и отделка White box\n' +
            'Купить — и переехать\n' +
            'Если вы купите картиру с готовой отделкой, вам не придётся искать специалистов, ездить по строительным магазинам, а главное — ждать, пока ремонт закончится. Мы используем только современные материалы: обои под покраску, ламинат, настенную и напольную керамическую плитку, плинтусы, натяжные потолки. Перед тем, как запустить материал в работу, мы обязательно его тестируем. Стены будут покрашены в белый — если захотите, их легко перекрасить в любой другой цвет.\n' +
            '\n' +
            'Оставьте себе творческую часть ремонта\n' +
            'Отделка White Box — это подготовка стен под поклейку обоев, оконных проёмов — под покраску, устройство внутренних перегородок, гидроизоляция и стяжка полов, разводка систем отопления, кондиционирования, вентиляции и электричества. Для отделки White box мы закупаем качественные сертифицированные материалы, а работы доверяем проверенным специалистам. Наши крупные объёмы закупок позволяют вам экономить: отделка White Box для вас будет дешевле, чем предчистовая отделка своими силами. К тому же вы сэкономите время и силы, освободив себя и близких от самых шумных и грязных работ. Всё, что вам останется — это приятная часть ремонта: выбор цветов, материалов и деталей интерьера, которые создадут в вашей новой квартире домашний уют.\n' +
            '\n',
          thumbnailUrl: require('./assets/9/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/9/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/9/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
      ],
    },
    {
      id: 10,
      title: 'Район',
      offers: [
        {
          id: 11,
          title: 'Мастерпланирование',
          description:
            'У каждого жилого района ПИК есть мастерплан — это план «организации жизни». Все пространства продуманы так, чтобы жителям было удобно ходить по своим повседневным делам, парковать машины, покупать продукты, водить детей в школы и детские сады, чтобы они могли гулять, отдыхать и заниматься спортом рядом с домом. Проектируя жилые районы, мы создаём цельное, современное и уютное пространство, а не выполняем минимальные требования по благоустройству. В среднем, 40% территории жилых районов ПИК — это ухоженные территории для прогулок и отдыха жителей, в то время как необходимый по строительным стандартам минимум — всего около 5%.\n' +
            'Как создаётся мастерплан:\n' +
            'Сначала соблюдаются все технико-экономические показатели (ТЭП) будущего жилого района — общая жилая площадь, площади отдельных квартир, площади технических помещений и так далее. Затем — по ТЭП — выстраивается уличная сетка района. Потом территория наполняется общественными пространствами — площадями, бульварами и тротуарами. После этого на территорию добавляются игровые площадки PlayHub, спортивные площадки и скейт-парки.В конце прорабатывается дизайн фасадов и малые архитектурные формы: скамейки, беседки, фонари.\n' +
            '\n' +
            'Принципы мастерпланирования\n' +
            'Практически в каждом проекте ПИК тестируются какие-то свежие и полезные идеи: например, «многоуровневый ландшафт». Таким образом, наш подход к оптимизации жизни в районе находится в процессе постоянного совершенствования. Однако наши основные принципы используются во всех новых проектах.\n' +
            '\n' +
            'Территория проекта логично делится на несколько важных в социальном плане частей: общее пространство для всех жителей района (пешеходные бульвары, площади, улицы между кварталами), соседское (дворы-парки) и личное (квартира).\n' +
            'Кварталы вместо микрорайонов. Микрорайон — устаревшая форма организации пространства, где во дворе умещается всё — магазины, дороги, парковки, школа и детский сад. Это неудобно и небезопасно. Мы строим кварталы, где внутри двора только парк, а всё остальное — вынесено за его пределы, но при этом находится всего в паре минут ходьбы. Непрерывные и безопасные пешеходные маршруты. Пример — бульвар в «Саларьево парке». Полный приоритет пешеходов во всех районах ПИК. Наши тротуары всегда широкие, а в тех местах, где всё же могут ездить автомобили, используются инструменты, ограничивающие их манёвры и скорость. Безбарьерная среда — у нас нет ступеней и заборов там, где они могли бы помешать жителям свободно перемещаться по кварталу. Дети, пожилые и маломобильные люди у нас не будут испытывать трудности с передвижением.',
          thumbnailUrl: require('./assets/11/1086x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/11/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/11/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/11/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 13,
          title: 'Спорт во дворе',
          description:
            'Площадка для уличных тренировок есть у каждого дома. Здесь установлены турники, брусья, ступени для кросс-фита и скамьи для пресса. На площадках не бывает скользко ни после дождя, ни в мороз: покрытие сделано из резиновой крошки.\n' +
            '\n' +
            'В некоторых проектах есть поля для мини-футбола и баскетбольные площадки — командный спорт здорово сближает соседей.',
          thumbnailUrl: require('./assets/13/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/13/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/13/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/13/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 12,
          title: 'Никаких преград',
          description:
            'Входы в подъезды на уровне земли: без ступеней, порогов и пандусов. Никаких препятствий для коляски, велосипеда или самоката вы не встретите и на всей территории проекта: бордюры мы делаем низкими, а тротуары — широкими.',
          thumbnailUrl: require('./assets/12/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/12/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/12/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/12/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 15,
          title: 'Всё рядом',
          description:
            'Спуститься, пройти несколько шагов и попить кофе, поужинать, купить продукты, получить посылки, собрать букет цветов, постричься и сделать маникюр — всё самое важное есть прямо в жилом квартале.',
          thumbnailUrl: require('./assets/15/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/15/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/15/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/15/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 14,
          title: 'Парк во дворе',
          description:
            'Двор-парк — это приватное пространство жителей: сюда можно попасть из подъезда или через калитку, приложив магнитный ключ. Во дворах-парках тихо и уютно: здесь много зелени и нет машин. В таком дворе приятно отдохнуть после работы или зарядиться энергией перед новым днём, погулять с детьми, поболтать с соседями, почитать в тени или позаниматься йогой.\n' +
            'Во дворе-парке есть места для спокойного отдыха и созерцания, для игр и приключений, для общения с внуками и занятий с детьми, для работы за ноутбуком в тени деревьев, для знакомства и общения соседей. Все активные и громкие площадки, например для баскетбола или мини-футбола, вынесены за периметр двора.\n' +
            '\n' +
            '\n' +
            'Двор-парк спроектирован так, чтобы жители больше времени проводили на свежем воздухе, чтобы каждый мог найти в нём занятие по душе. Мы стараемся создать безопасную, интересную и дружественную среду для всех жителей. Среду, где соседи знают друг друга, общаются и дружат.',
          thumbnailUrl: require('./assets/14/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/14/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/14/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/14/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
      ],
    },
    {
      id: 16,
      title: 'Детям',
      offers: [
        {
          id: 17,
          title: 'Игровые постранства PlayHub',
          description:
            'Это пространство для всех, центральное место притяжения всего района. Это среда, в которой зарождаются и формируются сообщества жителей, это место игр, встреч и общения. PlayHub помогает вовлечь детей в общественную жизнь, социализироваться. С точки зрения игры PlayHub существенно отличается от общепринятого понятия детской площадки. Это место для игры, развлечений и отдыха, творческое пространство, которое мы придумывали вместе со специалистами института детской психологии «Хочу гулять».\n' +
            'Playability — концепция игрового пространства, где одинаково комфортно и детям, и взрослым. Это мини-приключение, в котором люди лучше узнают друг друга.',
          thumbnailUrl: require('./assets/17/1068x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/17/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/17/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/17/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 18,
          title: 'Школы',
          description:
            'Мы проектируем школы так, чтобы они становились для детей не просто местом учёбы, а пространством, в котором хочется проводить свободное время, играть и общаться.',
          thumbnailUrl: require('./assets/18/1068x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/18/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/18/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/18/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 19,
          title: 'Детские сады',
          description:
            'Для наших детских садов мы используем лучший мировой опыт в архитектуре, психологии и педагогике. Интерьеры мы оформляем приятными на ощупь материалами, варьируем формы, объёмы, цвета и фактуры. Такое разнообразие побуждает детей к познанию, стимулирует их творческие способности.',
          thumbnailUrl: require('./assets/19/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/19/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/19/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/19/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
      ],
    },
    {
      id: 20,
      title: 'Безопасность',
      offers: [
        {
          id: 21,
          title: 'Закрытые дворы',
          description:
            'Это приватное пространство: сюда можно попасть из подъезда или через калитку, приложив магнитный ключ.',
          thumbnailUrl: require('./assets/21/1068x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/21/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/21/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/21/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 24,
          title: 'Видеонаблюдение',
          description:
            'Мы устанавливаем камеры во дворах, в подъездах и на паркингах. Если случится какая-то неприятность, видеозаписи помогут во всём разобраться.',
          thumbnailUrl: require('./assets/24/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/24/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/24/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/24/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 22,
          title: 'Освещение',
          description:
            'Чтобы вечерние прогулки были приятными и безопасными, вся территория проекта освещена: дворы, тротуары, парковки и дороги.',
          thumbnailUrl: require('./assets/22/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/22/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/22/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/22/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 23,
          title: 'Дворы без машин',
          description:
            'В наших дворах нет машин, поэтому жители любят в них гулять, общаться, отдыхать после работы и даже заниматься йогой.',
          thumbnailUrl: require('./assets/23/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/23/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/23/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/23/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
        {
          id: 25,
          title: 'Смарт-домофон',
          description:
            'Мы устанавливаем IP-домофоны, или смарт-домофоны, — ими можно управлять через приложение на смартфоне.',
          thumbnailUrl: require('./assets/25/526x480.jpg'),
          media: [
            {
              fullUrl: require('./assets/25/1024x800-1.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/25/1024x800-2.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
            {
              fullUrl: require('./assets/25/1024x800-3.jpg'),
              thumbnailUrl: '',
              mediaType: EMediaType.Image,
            },
          ],
        },
      ],
    },
  ],
};
